export interface Capabilities {
  googleEnabled: boolean; googleClientId: string | null;
  signupPlatforms: string[]; webSignupEnabled: boolean;
}
export interface Session { token: string; userId: string; displayName: string | null; onboardingComplete: boolean }
export interface Macros { kcal: number; proteinG: number; carbG: number; fatG: number }
export interface DayLog {
  date: string;
  entries: Array<Record<string, unknown>>;
  totals: Macros; target: Macros | null; remaining: Macros | null;
}

const TOKEN_KEY = 'orbit-health.session';

export const loadSession = (): Session | null => {
  const raw = window.sessionStorage.getItem(TOKEN_KEY);
  if (!raw) return null;
  try { return JSON.parse(raw) as Session; } catch { return null; }
};
export const saveSession = (s: Session | null): void => {
  if (s) window.sessionStorage.setItem(TOKEN_KEY, JSON.stringify(s));
  else window.sessionStorage.removeItem(TOKEN_KEY);
};

export class ApiError extends Error {
  constructor(public status: number, public body: Record<string, unknown>) {
    super(typeof body['message'] === 'string' ? body['message'] : (body['error'] as string) ?? `HTTP ${status}`);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const s = loadSession();
  const res = await fetch(`/api${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(s ? { Authorization: `Bearer ${s.token}` } : {}),
      ...(init.headers ?? {}),
    },
  });
  const body = res.status === 204 ? {} : await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401) saveSession(null);
    throw new ApiError(res.status, body as Record<string, unknown>);
  }
  return body as T;
}
